import { HttpClient } from '@angular/common/http';
import { TranslateLoader, TranslationObject } from '@ngx-translate/core';
import { Observable } from 'rxjs';

export class MappedTranslationLoader implements TranslateLoader {
  constructor(private readonly http: HttpClient) {}

  getTranslation(lang: string): Observable<TranslationObject> {
    let jsonFileName = lang;

    /**
     * We dont want to differentiate between en-US and en-GB
     * We will use the same translation file for both
     */
    if (lang.startsWith('en')) {
      jsonFileName = 'en-ANY';
    }

    const prefix = '/assets/i18n/';
    const suffix = `.json?cb=${new Date().getTime()}`;
    return this.http.get<TranslationObject>(
      `${prefix}${jsonFileName}${suffix}`,
    );
  }
}
